import * as tslib_1 from "tslib";
import { owaSuiteHeaderRendered } from '../actions/owaSuiteHeaderRendered';
import '@suiteux/suiteux-shell';
import { observer } from 'mobx-react';
import { getBposNavBarData } from 'owa-bpos-store';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { isFrameworkFeatureEnabled } from 'owa-feature-flags';
import { FeedbackForm } from 'owa-feedback';
import { FeatureFlagsHeader, FeatureFlagsList } from 'owa-header-pane';
import { signout } from 'owa-header/lib/actions/signout';
import SkypeCharm from 'owa-header/lib/components/SkypeCharm';
import { handleSocPostMessageEvents } from 'owa-help-charm';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import resetSearch from 'owa-options-search/lib/actions/resetSearch';
import { QuickOptions } from 'owa-options-view';
import { getConfig } from 'owa-service/lib/config';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { logCalendarUsage } from 'owa-shared-analytics';
import strings from 'owa-strings/owa-common-strings';
import { closeFlexPane } from 'owa-suite-header-apis';
import { getCurrentThemeId, getHeaderImageData, getPaletteAsRawColors, getCobrandingThemeResources, } from 'owa-theme';
import { FolderPicker, TodoPanel } from 'owa-todos';
import { lazyLaunchInAppFeedback } from 'owa-uservoice';
import isWorkloadSupported from 'owa-workloads/lib/utils/isWorkloadSupported';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { resolve as urlResolve } from 'url';
import { WhatsNewContainer } from 'owa-whats-new';
import whatsNewStrings from 'owa-strings/owa-whatsnew-strings';
import { getActiveCharm, toggleCharm, deactivateCharm } from 'owa-header-store';
import getStartedStrings from 'owa-strings/owa-getstarted-strings';
import { GetStartedTaskContainer } from 'owa-get-started';
import { lazyOnNotificationReceived, lazyOnHideNotificationReceived } from 'owa-skype';
import { getAccessTokenforResource } from 'owa-tokenprovider';
import { showModal } from 'owa-modal';
import { OpenAnotherMailboxDialog } from './OpenAnotherMailboxDialog';
import { getNewScope } from 'owa-url';
import { SuiteHeader, } from '@suiteux/suiteux-shell-react';
import { setAppPaneUnderlayVisibility } from 'owa-application/lib/actions/setAppPaneUnderlayVisibility';
import OwaSuiteHeaderButton from 'owa-suite-header/lib/components/OwaSuiteHeaderButton';
var headerStyles = require('./OwaSuiteHeader.scss');
var toDoStyles = require('owa-header-pane/lib/components/TodoPane.scss');
var whatsNewStyles = require('owa-header-pane/lib/components/WhatsNewPane.scss');
var classNames = require('classnames/bind');
export var owaSettingsButtonID = 'owaSettingsButton';
var owaToDoButtonID = 'owaToDoButton';
var owaFeatureFlagsButtonID = 'owaFeatureFlagsButton';
var owaFeedbackButtonID = 'owaFeedbackButton';
var owaWhatsNewButtonID = 'whatsnew';
var owaGetStartedButtonID = 'getstarted';
var owaSettingsFlexPaneID = 'OwaSettings';
var ShellMailId = 'ShellMail';
var OwaSuiteHeader = /** @class */ (function (_super) {
    tslib_1.__extends(OwaSuiteHeader, _super);
    function OwaSuiteHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.isMaxHelpPaneEnabled = isMailFeatureEnabled('help-o365ShellHeader-MaxPane');
        _this.charmContainers = {};
        _this.headerChatEnabled = isMailFeatureEnabled('chat-o365shellheader') &&
            !isControlFeatureEnabled('fwk-skypeBusiness');
        _this.onLinkClick = function (data) {
            if (data && data.Id == 'Calendar') {
                logCalendarUsage('ModuleSwitchToCalendar', {
                    source: 'mailWaffle',
                });
            }
        };
        _this.signout = function (eventArgs) {
            eventArgs.triggerEvent.preventDefault();
            signout(location);
        };
        _this.flexPaneVisiblityChanged = function (isVisible, props) {
            setAppPaneUnderlayVisibility('suiteFlexPane', isVisible, true /* isShrinkable */);
        };
        _this.getNavBarData = function () {
            var owaNavBarData = getBposNavBarData();
            if (owaNavBarData) {
                var navBarData = tslib_1.__assign({}, owaNavBarData, { CurrentMainLinkElementID: ShellMailId, ThemeDataOverride: _this.createThemeData(), AppBrandTheme: _this.owaBrandTheme });
                return navBarData;
            }
            else {
                return null;
            }
        };
        _this.createCustomLayout = function () {
            var customHeaderButtons = [];
            if (!isFrameworkFeatureEnabled('fwk-partner-code-off') &&
                isControlFeatureEnabled('fwk-skypeBusiness')) {
                var skypeKey_1 = 'skype';
                var skypeCharm = (React.createElement(OwaSuiteHeaderButton, { ref: function (component) { return (_this.charmContainers[skypeKey_1] = component); } },
                    React.createElement(SkypeCharm, { key: skypeKey_1 })));
                customHeaderButtons.push(_this.createChildControlFromCharm(skypeKey_1, skypeCharm));
            }
            if (_this.headerChatEnabled) {
                customHeaderButtons.push({
                    id: 'owaChatButton',
                    nativeControlID: 'ChatIcon',
                });
            }
            if (isControlFeatureEnabled('todo-panel')) {
                customHeaderButtons.push(
                // The custom header button for To Do
                {
                    id: 'owaToDoBtn',
                    headerButtonRenderData: {
                        id: owaToDoButtonID,
                        iconFontName: '\uf75b',
                        iconFontFamily: 'controlIcons',
                        ariaLabel: function () { return strings.todoCharm_ariaLabel; },
                    },
                });
            }
            customHeaderButtons.push(
            // The custom header button for Settings
            {
                id: 'owaSettingsBtn',
                headerButtonRenderData: {
                    id: owaSettingsButtonID,
                    iconFontName: '\ue713',
                    iconFontFamily: 'controlIcons',
                    ariaLabel: function () { return strings.settingsCharm_ariaLabel; },
                },
            }, 
            // Add in our own Help control
            { id: 'owaHelpButton', nativeControlID: 'HelpIcon' });
            if (isControlFeatureEnabled('fwk-feedbackCharm')) {
                customHeaderButtons.push(
                // The custom header button for feedback charm
                {
                    id: 'owaFeedbackBtn',
                    headerButtonRenderData: {
                        id: owaFeedbackButtonID,
                        iconFontName: '\ue76e',
                        iconFontFamily: 'controlIcons',
                        ariaLabel: function () { return strings.feedbackCharm_ariaLabel; },
                    },
                });
            }
            if (isFrameworkFeatureEnabled('fwk-devTools')) {
                customHeaderButtons.push(
                // The custom header button for feature flags
                {
                    id: 'owaFlagBtn',
                    headerButtonRenderData: {
                        id: owaFeatureFlagsButtonID,
                        iconFontName: '\ue7c1',
                        iconFontFamily: 'controlIcons',
                        ariaLabel: function () { return 'featureflags charm'; },
                    },
                });
            }
            if (_this.props.rightCharms) {
                _this.props.rightCharms
                    .filter(function (charm) { return !!charm; })
                    .map(
                // Convert all OWA charms into custom shell header controls
                function (charm) { return _this.createChildControlFromCharm(charm.key, charm); })
                    .forEach(function (control) { return customHeaderButtons.push(control); });
            }
            var searchContainerClasses = classNames(headerStyles.searchContainer, isMailFeatureEnabled('sea-centered') && headerStyles.searchContainerCentered);
            var layout = {
                leftCustomizationRegion: {
                    includeAppLauncher: true,
                },
                centerCustomizationRegion: {
                    alignItems: 'center',
                    flex: '1 0 auto',
                    children: [
                        // Left aligned items
                        {
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            flex: '1 0 auto',
                            children: [
                                {
                                    children: [
                                        isFrameworkFeatureEnabled('fwk-cobranding')
                                            ? {
                                                id: 'tenantLogo',
                                                nativeControlID: 'TenantLogo',
                                            }
                                            : null,
                                        {
                                            id: 'owaBranding',
                                            nativeControlID: 'O365Branding',
                                        },
                                    ],
                                    flex: "0 0 " + ((_this.props.searchAlignmentWidth ||
                                        _this.props.userConfiguration.UserOptions
                                            .NavigationBarWidth) - 48 // Subtract the button width
                                    ) + "px",
                                },
                                {
                                    id: 'owaSearchBox',
                                    flex: '1 1 auto',
                                    render: function (container) {
                                        return ReactDOM.render(React.createElement("div", { className: searchContainerClasses }, _this.props.children), container);
                                    },
                                },
                            ],
                        },
                        // Right aligned items
                        {
                            flex: '0 0 auto',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            children: customHeaderButtons,
                        },
                    ],
                },
                rightCustomizationRegion: {
                    includeMeControl: true,
                },
                flexPaneCollection: [
                    {
                        flexPaneID: 'OwaFeedback',
                        flexPaneTitle: function () { return strings.feedbackCharm_ariaLabel; },
                        triggerControlID: owaFeedbackButtonID,
                        containerClassName: headerStyles.customFlexPane,
                        render: function (container) {
                            ReactDOM.render(React.createElement(FeedbackForm, { onSendFeedback: function () {
                                    window.O365Shell.FlexPane.CloseFlexPaneForProvider('OwaFeedback');
                                } }), container);
                        },
                    },
                    {
                        flexPaneID: 'OwaFeatureFlags',
                        flexPaneTitle: function () { return 'Feature Flags'; },
                        triggerControlID: owaFeatureFlagsButtonID,
                        containerClassName: headerStyles.customFlexPane,
                        render: _this.renderInsideFlexPane([React.createElement(FeatureFlagsHeader, null), React.createElement(FeatureFlagsList, null)], 'Feature Flags'),
                    },
                    {
                        flexPaneID: owaSettingsFlexPaneID,
                        flexPaneTitle: function () { return strings.settingsCharm_ariaLabel; },
                        onFlexPaneClose: resetSearch,
                        triggerControlID: owaSettingsButtonID,
                        containerClassName: headerStyles.customFlexPane,
                        render: _this.renderInsideFlexPane(React.createElement(QuickOptions, { onDismiss: _this.onQuickSettingsDismiss }), strings.settingsCharm_ariaLabel),
                    },
                    {
                        flexPaneID: 'OwaToDo',
                        flexPaneTitle: function () { return strings.panelHeaderText; },
                        triggerControlID: owaToDoButtonID,
                        containerClassName: classNames(toDoStyles.todoFlexPaneContent, headerStyles.customFlexPane),
                        customTitle: function (container) {
                            ReactDOM.render(React.createElement(FolderPicker, null), container);
                        },
                        render: _this.renderInsideFlexPane(React.createElement(TodoPanel, { hideFolderPicker: true }), strings.panelHeaderText, toDoStyles.todoFlexPanePanelContainer),
                    },
                    {
                        flexPaneID: 'OwaWhatsNew',
                        flexPaneTitle: function () { return whatsNewStrings.whatsNew_FlexPane_Title; },
                        triggerControlID: owaWhatsNewButtonID,
                        containerClassName: headerStyles.customFlexPane,
                        onFlexPaneOpen: function () {
                            if (getActiveCharm() !== 8 /* WhatsNewCharm */) {
                                toggleCharm(8 /* WhatsNewCharm */);
                            }
                        },
                        onFlexPaneClose: function () { return deactivateCharm(8 /* WhatsNewCharm */); },
                        render: _this.renderInsideFlexPane(React.createElement(WhatsNewContainer, null), whatsNewStrings.whatsNew_FlexPane_Title, whatsNewStyles.content),
                    },
                    {
                        flexPaneID: 'OwaGetStarted',
                        flexPaneTitle: function () { return getStartedStrings.getStarted_FlexPane_Title; },
                        triggerControlID: owaGetStartedButtonID,
                        containerClassName: headerStyles.customFlexPane,
                        onFlexPaneOpen: function () {
                            if (getActiveCharm() !== 7 /* GetStartedCharm */) {
                                toggleCharm(7 /* GetStartedCharm */);
                            }
                        },
                        onFlexPaneClose: function () { return deactivateCharm(7 /* GetStartedCharm */); },
                        render: _this.renderInsideFlexPane(React.createElement(GetStartedTaskContainer, null), getStartedStrings.getStarted_FlexPane_Title, whatsNewStyles.content),
                    },
                ],
            };
            return layout;
        };
        _this.renderInsideFlexPane = function (elements, flexPaneTitle, className) { return function (container) {
            return ReactDOM.render(React.createElement("div", { tabIndex: -1, role: 'complementary', "aria-label": flexPaneTitle, className: className }, elements), container);
        }; };
        _this.onQuickSettingsDismiss = function () {
            closeFlexPane(owaSettingsFlexPaneID);
        };
        _this.createThemeData = function (themeId) {
            if (themeId === void 0) { themeId = getCurrentThemeId(); }
            var themeData = {
                UserPersonalizationAllowed: true,
                IsDarkTheme: getIsDarkTheme(),
                UserThemeId: themeId,
                UserThemePalette: tslib_1.__assign({}, _this.generateSuitePaletteFromFabricPalette(getPaletteAsRawColors(themeId)), { BackgroundImageUrl: getHeaderImageData(themeId).primary }),
                TenantThemePalette: isFrameworkFeatureEnabled('fwk-cobranding')
                    ? _this.generateSuitePaletteFromFabricPalette(getCobrandingThemeResources().themePalette)
                    : null,
            };
            return themeData;
        };
        _this.createHelpSublinks = function () {
            var helpLinks = [
                _this.createHelpLink('OwaFeedbackLink', strings.feedbackLink, 'javascript:void(0)', function () {
                    lazyLaunchInAppFeedback.importAndExecute();
                    return false;
                }),
                _this.createHelpLink('OwaHelpLink', strings.helpLink, 'https://go.microsoft.com/fwlink/?linkid=853225'),
                _this.createHelpLink('OwaPrivacyLink', strings.privacyLink, 'https://go.microsoft.com/fwlink/?linkId=521839'),
                _this.createHelpLink('OwaTermsLink', strings.termsLink, 'https://www.microsoft.com/en-us/servicesagreement'),
            ];
            if (isWorkloadSupported(2 /* Calendar */)) {
                helpLinks.push(_this.createHelpLink('OwaCalendarAbuseLink', strings.reportCalendarAbuseLink, 'https://www.microsoft.com/concern/calendarabuse'));
            }
            return helpLinks;
        };
        _this.createHelpLink = function (id, helpText, url, action) {
            return {
                Id: id,
                Text: helpText,
                Url: url,
                TargetWindow: '_blank',
                Action: action,
            };
        };
        _this.createMeSublinks = function () {
            return _this.props.userConfiguration.SessionSettings.WebSessionType ===
                0 /* Business */ && isMailFeatureEnabled('auth-openAnotherMailbox')
                ? [
                    {
                        Id: 'OwaOpenTargetMailboxLink',
                        Text: strings.openAnotherMailbox,
                        Url: 'javascript:void(0)',
                        Action: _this.showOpenAnotherMailboxDialog,
                    },
                ]
                : [];
        };
        _this.showOpenAnotherMailboxDialog = function () {
            var _a = tslib_1.__read(showModal(OpenAnotherMailboxDialog), 1), modalPromise = _a[0];
            modalPromise.then(function (targetMailbox) {
                if (targetMailbox && targetMailbox.length > 0) {
                    window.open(getNewScope(targetMailbox), '_blank');
                }
            });
        };
        _this.owaBrandTheme = _this.createThemeData('base').UserThemePalette;
        // temporary added until Shell adds OWA to chat enabled workload list.
        if (_this.headerChatEnabled) {
            window.sessionStorage.ShellOverrides = JSON.stringify({
                TeamsChatEnabled: true,
            });
        }
        return _this;
    }
    OwaSuiteHeader.prototype.componentDidMount = function () {
        var _this = this;
        if (this.isMaxHelpPaneEnabled) {
            window.addEventListener('message', handleSocPostMessageEvents, false);
        }
        if (this.headerChatEnabled) {
            window.addEventListener('swc:core:ready', function () {
                _this.onSwcCoreReady();
            });
        }
    };
    /**
     * Register for Skype notifications when SWC is initialized.
     *
     * @private
     * @memberof OwaSuiteHeader
     */
    OwaSuiteHeader.prototype.onSwcCoreReady = function () {
        var _this = this;
        window.removeEventListener('swc:core:ready', function () {
            _this.onSwcCoreReady();
        });
        if (swc) {
            swc.API.registerEvent('receivedNotification', lazyOnNotificationReceived.importAndExecute);
            swc.API.registerEvent('hideNotification', lazyOnHideNotificationReceived.importAndExecute);
        }
    };
    OwaSuiteHeader.prototype.componentWillUnmount = function () {
        if (this.isMaxHelpPaneEnabled) {
            window.removeEventListener('message', handleSocPostMessageEvents);
        }
    };
    OwaSuiteHeader.prototype.render = function () {
        return (React.createElement("div", { tabIndex: -1, role: "banner" },
            React.createElement(SuiteHeader, { onLinkClick: this.onLinkClick, culture: this.props.userConfiguration.SessionSettings.UserCulture, language: this.props.userConfiguration.SessionSettings.UserLanguage, isRTL: this.props.userConfiguration.SessionSettings.IsUserCultureRightToLeft, isConsumer: false, userDisplayName: this.props.userConfiguration.SessionSettings.UserDisplayName, userPrincipalName: this.props.userConfiguration.SessionSettings.UserPrincipalName, workloadID: 'Exchange', appBrandTheme: this.owaBrandTheme, currentMainLinkElementID: ShellMailId, themeData: this.createThemeData(), customLayout: this.createCustomLayout(), helpSublinks: this.createHelpSublinks(), meSublinks: this.createMeSublinks(), shellAssetsContainerOverride: "" + urlResolve(getPackageBaseUrl(), 'resources/suiteux-shell'), navBarData: this.getNavBarData(), onSignOut: this.signout, onFlexPaneVisibilityChanged: this.flexPaneVisiblityChanged, shellDataOverrides: {
                    SuiteServiceUrl: "" + window.location.origin + getConfig().baseUrl + "/service.svc",
                    MAXHelpEnabled: this.isMaxHelpPaneEnabled,
                }, renderedCallback: function () {
                    owaSuiteHeaderRendered();
                }, getAccessTokenforResource: this.headerChatEnabled ? this.getToken : null, disableToasts: true })));
    };
    /**
     * @ToDo : Please edit this method appropriately.
     *
     * @private
     * @param {string} resourceAudience
     * @returns {Promise<string>}
     * @memberof OwaSuiteHeader
     */
    OwaSuiteHeader.prototype.getToken = function (resourceAudience) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAccessTokenforResource(resourceAudience)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    OwaSuiteHeader.prototype.createChildControlFromCharm = function (key, charm) {
        var _this = this;
        return {
            id: key,
            render: function (container) {
                return ReactDOM.render(React.createElement(OwaSuiteHeaderButton, { ref: function (component) { return (_this.charmContainers[key] = component); } }, charm), container);
            },
            enterSearchMode: function (container) {
                return _this.charmContainers[key] &&
                    _this.charmContainers[key].setState({ searchMode: true });
            },
            exitSearchMode: function (container) {
                return _this.charmContainers[key] &&
                    _this.charmContainers[key].setState({ searchMode: false });
            },
        };
    };
    OwaSuiteHeader.prototype.generateSuitePaletteFromFabricPalette = function (palette) {
        return {
            LighterAlt: palette.themeLighterAlt,
            Darker: palette.themeDarker,
            Dark: palette.themeDark,
            DarkAlt: palette.themeDarkAlt,
            Light: palette.themeLight,
            Primary: palette.themePrimary,
            Secondary: palette.themeSecondary,
            Tertiary: palette.themeTertiary,
            Lighter: palette.themeLighter,
            NavBar: palette.headerBackground,
            DefaultText: palette.headerTextIcons,
            DefaultBackground: palette.headerButtonsBackground,
            HoverBackground: palette.headerButtonsBackgroundHover,
            AppName: palette.headerBrandText,
            SearchNavBar: palette.headerBackgroundSearch,
            SearchHoverBackground: palette.headerButtonsBackgroundSearchHover,
        };
    };
    OwaSuiteHeader = tslib_1.__decorate([
        observer
    ], OwaSuiteHeader);
    return OwaSuiteHeader;
}(React.Component));
export default OwaSuiteHeader;
//# sourceMappingURL=OwaSuiteHeader.js.map